/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import "./Product.css";
import { connect } from "react-redux";
import {
  AddToCartAction,
  getBasketSelector,
} from "../../Reducers/AddToCartReducer";

function Product({ id, title, price, image, rating, addToCart, cartValue }) {
  const addToBasket = () => {
    addToCart({
      id,
      title,
      price,
      image,
      rating,
    });
  };
  return (
    <div className="product" key={id}>
      <div className="product__info">
        <p>{title}</p>
        <p className="product__price">
          <small>$</small>
          <strong>{price}</strong>
        </p>
        <div className="product__rating">
          {/* new learning */}
          {Array(rating)
            .fill()
            .map((_) => (
              <p>⭐</p>
            ))}
        </div>
      </div>
      <img src={image} alt={`product image ${title}`} />
      <button onClick={addToBasket}>Add to Cart</button>
    </div>
  );
}

export default connect((state) => ({ cartValue: getBasketSelector(state) }), {
  addToCart: AddToCartAction,
})(Product);
